import React from 'react';
import { ECHARTSCOLOR } from '@/pages/intelligence/utils/echartsConst';
import { Bubble } from '@home/components/TeaComponents';
import classNames from 'classnames';
import './index.scss';

interface IMultipleChoiceProps {
  // value 选中的值; 全选态
  value: boolean;
  // onChange 选择事件
  onChange: (nextCheck: boolean) => void;
  // disabled 是否禁用
  disabled?: boolean;
  bubbleContent?: React.ReactNode;
  // 隐藏元素
  isLabelHide?: boolean;
  // 是否半选
  indeterminate?: boolean;
  // color 颜色
  color?: string;
}
const MultipleChoice = (props: IMultipleChoiceProps) => {
  const {
    value: checked,
    onChange,
    disabled,
    bubbleContent,
    // 隐藏元素
    isLabelHide,
    indeterminate,
    color = ECHARTSCOLOR[0],
  } = props;

  return (
    <Bubble content={bubbleContent} dark arrowPointAtCenter >
      <input
        type="checkbox"
        className={classNames({
          'dbi-table-indeterminate': indeterminate,
          'dbi-table-check': checked,
          'dbi-table-nocheck': !checked,
        })}
        checked={checked}
        style={{
          backgroundColor: checked || indeterminate ? color : '',
          borderColor: checked || indeterminate ? color : '',
          display: isLabelHide ? 'none' : '',
        }}
        onChange={() => {
          /** 半选状态时点击为取消选中 */
          const nextCheck = indeterminate ? false : !checked;
          onChange(nextCheck);
        }}
        disabled={disabled}
      />
    </Bubble>
  );
};

export default MultipleChoice;
